import { ChangeDetectorRef, Component, Input, Output, OnInit, OnChanges, SimpleChanges, EventEmitter, AfterViewInit } from '@angular/core';
import { BlindListComponent } from '@features/blind-list/blind-list.component';
import { ShareService } from '@core/services/share-data/share-data.service';
import { EngineService } from '@core/services/engine/engine.service';
import { ServerDataService } from '@core/services/server-data/server-data.service';
import { SaveSessionBlindsService } from '@core/services/save-session-blinds/save-session-blinds.service';
import { ActivatedRoute } from '@angular/router';
import { ScreenshotService } from '@core/services/screenshot/screenshot.service';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';
import { PassDataService } from '@core/services/pass-data/pass-data.service';
import { ScreenshotToBlindService } from '@core/services/screenshot-to-blind/screenshot-to-blind.service';
import { BlindStateService } from '@core/services/blind-state/blind-state.service';
import { VariantService } from '@core/services/variant/variant.service';
import { PartAvailabilityService } from '@core/services/part-availability/part-availability.service';
import { ToolBarComponent } from '@features/tool-bar/tool-bar.component';
import { SetupPageService } from '@core/services/setup-page/setup-page.service';
import { AccordionSectionService } from '@features/blind-list/services/accordion-section.service';
import { BlindData, SectionKeysEnum } from '@root/app.interfaces';
import { ResetAppService } from '@core/services/reset-app/reset-app.service';

@Component({
	selector: 'app-interior-list',
	templateUrl: './interior-list.component.html',
	styleUrls: ['../blind-list.component.scss', '../blind-list.responsive.scss'],
	providers: [AccordionSectionService],
})
export class InteriorListComponent extends BlindListComponent implements OnInit, AfterViewInit, OnChanges {
	@Input() index: number;
	@Input() blindsListComponent: BlindListComponent;

	@Output() setupData = new EventEmitter();

	readonly sections = [
		SectionKeysEnum.Material,
		SectionKeysEnum.Size,
		SectionKeysEnum.Operation,
		SectionKeysEnum.FrameColor,
		SectionKeysEnum.ColorOfFixtures,
		SectionKeysEnum.Mounting,
	];

	blind: BlindData;

	constructor(
		public shareDataService: ShareService,
		public engineService: EngineService,
		public resetAppService: ResetAppService,
		public serverDataService: ServerDataService,
		public saveSessionBlind: SaveSessionBlindsService,
		public route: ActivatedRoute,
		public screenShotService: ScreenshotService,
		public screenshotToBlindService: ScreenshotToBlindService,
		public sessionStorageService: SessionStorageService,
		public passDataService: PassDataService,
		public changeDetection: ChangeDetectorRef,
		public blindStateService: BlindStateService,
		public partAvailabilityService: PartAvailabilityService,
		public variantService: VariantService,
		public toolBarComponent: ToolBarComponent,
		public setupPageService: SetupPageService,
		public accordionSectionService: AccordionSectionService<SectionKeysEnum>,
	) {
		super(
			shareDataService,
			engineService,
			resetAppService,
			serverDataService,
			saveSessionBlind,
			route,
			screenShotService,
			screenshotToBlindService,
			sessionStorageService,
			passDataService,
			changeDetection,
			blindStateService,
			partAvailabilityService,
			variantService,
			toolBarComponent,
			setupPageService,
			accordionSectionService,
		);
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.blind = this.blindsData[this.index];

		setTimeout(this.blindNameSave.bind(this, this.blind.blind_id));
		this.getModelLoadedStatus.unsubscribe();
		this.getScreenShot.unsubscribe();
		this.getBlindsData.unsubscribe();
		this.getBlindDelete.unsubscribe();
		this.getSelectedModel.unsubscribe();
		this.getAccordionMobileBlindList.unsubscribe();
		this.getViewType.unsubscribe();
		this.getAccordionBlindSubscription.unsubscribe();
		this.blindsAvailabilitySubs?.unsubscribe();
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();
		this.registerAccordionSections();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.index.firstChange) {
			this.blind = this.blindsListComponent.blindsData[this.index];
			this.blindsData = this.blindsListComponent.blindsData;
		}
	}

	blindNameSave(id: any): void {
		super.blindNameSave(id);
		if (this.blindsListComponent.blindsData) {
			this.blindsListComponent.blindsData[this.index].name = this.blind.name;
		}
	}

	onBlindItemDescriptionHandler<T>(event: T, id?: number): void {
		super.onBlindItemDescriptionHandler(event, id);
		this.setupData.emit(event);
	}
}
